import { createReducer } from "@ngrx/store";
import { type AppState } from "./app.state";

const initialState: AppState = {
  appName: 'LayoverAppAdmin'
}

export const appReducer = createReducer<AppState>(
  initialState
)
